import React, { lazy, Suspense } from 'react';

import NavContainer from './components/navV2/NavContainer';

import featureFlags from './util/featureFlags';

const ModalRoot = lazy(() => import('./components/common/ModalRoot'));
const ToastsContainer = lazy(() => import('./components/toastsContainer'));
const FeatureToggle = lazy(() => import('./components/FeatureToggle'));
const SideDrawerRoot = lazy(() => import('./components/common/SideDrawerRoot'));

const showFeatureToggle = featureFlags.get('featureToggle');
const enableSideDrawer = featureFlags.get('registryShareOptions');

function App() {
  return (
    <React.Fragment>
      <a href="/webaccessibility" tabIndex="0" className="accessibility-link screen-only">
        Web Accessibility
      </a>
      <NavContainer />
      <Suspense fallback={null}>
        <ModalRoot />
        {enableSideDrawer && <SideDrawerRoot />}
        <ToastsContainer />
        {showFeatureToggle && <FeatureToggle />}
      </Suspense>
    </React.Fragment>
  );
}

export default App;
